__turbopack_context__.v({
  "shippingText": "styles-module__yvfvhG__shippingText",
  "submitButton": "styles-module__yvfvhG__submitButton",
  "timeWrapper": "styles-module__yvfvhG__timeWrapper",
});
